import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/work",
    name: "Work",
    component: () => import("../views/Work.vue"),
  },
  {
    path: "/products/:name",
    name: "ProductsSlected",
    component: () => import("../components/Products/ProductSelect.vue"),
  },
  {
    path: "/products",
    name: "Products",
    component: () => import("../views/Product.vue"),
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/News.vue"),
  },
  {
    path: "/news/:title",
    name: "NewsDetail",
    component: () => import("../components/News/NewsSelected.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/Contact.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    // if (to.name !== 'ProductsSlected') {
      return { x: 0, y: 0 };
    // }
  },
});

export default router;
